module.exports = __webpack_public_path__ + "6d0dabefa267da7574fcae486bac6447.png";